import { Box } from '@mui/material'
import SectionHeader from 'components/Common/SectionHeader'
import { useWizard } from 'components/RouteWizard/Wizard'
import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import carshr from '../../../assets/icon/Icon-carshr.svg'
import coach from '../../../assets/icon/Icon-coach.svg'
import scooter from '../../../assets/icon/Icon-scooter.svg'
import taxi from '../../../assets/icon/Icon-taxi.svg'
import JourneyTypeButton from '../../../components/Bookings/JourneyTypeButton/JourneyTypeButton'

export function JourneyType() {
  const history = useHistory()
  const { addData } = useWizard()
  const hasRedirectedRef = useRef(false)

  // This has been implemented to go directly to taxi booking
  useEffect(() => {
    if (hasRedirectedRef.current) return

    hasRedirectedRef.current = true
    addData({ type: 'taxi' })
    history.replace('/admin/bookings/create/account?type=taxi')
  }, [addData, history])

  // The code below will allow the user to select the type of transport

  const handleSelect = (value: string) => {
    addData({ type: value })
    history.push(`/admin/bookings/create/account?type=${value}`)
  }

  return (
    <Box component="div" sx={{ width: '100%' }}>
      <SectionHeader
        title="Mode of Transport"
        subtitle="Select the journey transport type."
      />
      <Box
        component="div"
        sx={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '350px',
          gap: '20px',
          '@media (min-width: 1200px)': {
            gridTemplateColumns: '350px 350px',
          },
          '@media (min-width: 1600px)': {
            gridTemplateColumns: '350px 350px',
          },
        }}
      >
        <JourneyTypeButton
          buttonName="Ride"
          buttonIcon={taxi}
          onClick={() => handleSelect('taxi')}
          active={true}
        />
        {/* <JourneyTypeButton
          buttonName="Chauffeur"
          buttonIcon={chauf}
          onClick={() => handleSelect('chauffeur')}
          active={false} 
        />*/}
        <JourneyTypeButton
          buttonName="Coach"
          buttonIcon={coach}
          onClick={() => handleSelect('coach')}
          active={false}
        />
        {/* <JourneyTypeButton
          buttonName="Ride Hail"
          buttonIcon={hail}
          onClick={() => handleSelect('hail')}
          active={false}
        /> */}
        <JourneyTypeButton
          buttonName="Car Hire/Share"
          buttonIcon={carshr}
          onClick={() => handleSelect('carshr')}
          active={false}
        />
        <JourneyTypeButton
          buttonName="Micro-Mobility"
          buttonIcon={scooter}
          onClick={() => handleSelect('micro')}
          active={false}
        />
      </Box>
    </Box>
  )
}
export default JourneyType
